export default __webpack_public_path__ + "static/media/icon-dropdown.d8cf961f.svg";